import { fmtPrice } from "@/lib/constants";

export const VAT_MENTION = "TVA non applicable, article 293 B du CGI";

export const BillingTotals = ({ c }) => {
  const rows = [["Main-d'œuvre", c.labor, "labor"], ["Matériel et logiciels", c.materiel, "materiel"], ["Déplacements", c.deplacement, "deplacement"],
    ["Autres prestations et frais", c.autres, "autres"], ["Remises", -c.remise, "remise"]];
  const free = c.billing_status === "offerte" || c.billing_status === "non_facturable";
  return (
    <div className="space-y-1 rounded-lg border border-cyan-400/20 bg-[#0A1630]/60 p-3 text-sm" data-testid="billing-totals">
      {rows.map(([k, v, t]) => (
        <div key={k} className="flex justify-between text-slate-300"><span>{k}</span><span data-testid={`billing-total-${t}`}>{fmtPrice(v)}</span></div>
      ))}
      {c.free_value > 0 && <div className="flex justify-between text-xs text-slate-500"><span>Offert / non facturable (non compté)</span><span>{fmtPrice(c.free_value)}</span></div>}
      {free && <p className="text-xs text-cyan-300">Prestation {c.billing_status === "offerte" ? "offerte" : "non facturable"} : rien à facturer (valeur {fmtPrice(c.total)}).</p>}
      <div className="flex justify-between border-t border-white/10 pt-2 font-semibold text-white">
        <span>{c.vat_enabled ? "Montant total HT à facturer" : "Montant total à facturer"}</span><span data-testid="billing-total-to-bill">{fmtPrice(c.to_bill)}</span>
      </div>
      {c.vat_enabled ? (
        <>
          <div className="flex justify-between text-slate-300"><span>TVA {c.vat_rate} %</span><span>{fmtPrice(c.vat_amount)}</span></div>
          <div className="flex justify-between font-semibold text-white"><span>Total TTC</span><span data-testid="billing-total-ttc">{fmtPrice(c.to_bill_ttc)}</span></div>
        </>
      ) : <p className="text-xs text-slate-500" data-testid="billing-vat-mention">{VAT_MENTION}</p>}
    </div>
  );
};
